import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Link,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

//Events
import EventBus from "../../EventBus";

//Enums
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";

//Services
import ComboService from "../../services/ComboService";

//Components
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";

//Common Styles
import {
  CustomTableRowTR,
  StyledTable,
  TableData,
  TableHeader,
  TableTopHeader,
  TableWrapper,
  Title,
} from "../../styles/commonStyles";
import { formatDateTime, formatDateTimeWithSeconds } from "../../utils/DateTimeUtils";
import { OneMealService } from "../../services/OneMealService";

const comboService = new ComboService();
const oneMealService = new OneMealService()

const getModuleHref = (id: number | string, module: string) => {
  return `/#/${module}/${id}/show`;
};

const ComboLapsedVists = (props: any) => {
  let [loading, setLoading] = useState<boolean>(false);
  let [lapsedVisits, setLapsedVisits] = useState<any>([]);

const refreshData = useCallback(
    () => {
    setLoading(true);
    comboService
        .getAllLapsedVisitsOfCombo(props?.referenceId)
        .then((data) => {
        setLapsedVisits(data);
        console.log(data);
        
        setLoading(false);
        })
        .catch((err) => {
        setLoading(false);
        });
    },
    [props?.referenceId]
);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  return (
    <>
      <TableWrapper>
        <TableTopHeader>
          <Title>{'Lapsed Visits'}</Title>
        </TableTopHeader>

        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 2,
            overflowX: "auto",
            msOverflowStyle: "none",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <StyledTable size="small">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "rgba(232, 235, 237, 0.3) !important",
                }}
              >
                <TableHeader>ID</TableHeader>
                <TableHeader>Oms ID</TableHeader>
                <TableHeader>Discount Coupon ID</TableHeader>
                <TableHeader>Lapsed At</TableHeader>
                <TableHeader>Created At</TableHeader>
                <TableHeader>Updated At</TableHeader>
                <TableHeader align="right">Action</TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (
                <TableRow>
                  <TableCell colSpan={11} align="center" sx={{ py: 4 }}>
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              )}
              {!loading && lapsedVisits.length ? (
                lapsedVisits.map((request: any) => {
                  return (
                    <CustomTableRowTR key={request.id}>
                      <TableData>
                        {request?.id || "-"}
                      </TableData>
                      <TableData>
                        {request?.omsId ? (
                            <Link
                            href={getModuleHref(request.omsId, "OneMealService")}
                            underline="hover"
                            >
                            {request.omsId}
                            </Link>
                        ) : (
                            "-"
                        )}
                      </TableData>
                      <TableData>
                        {request?.discountCouponV2Id ? (
                            <Link
                            href={getModuleHref(request.discountCouponV2Id, "CouponsV2")}
                            underline="hover"
                            >
                            {request.discountCouponV2Id}
                            </Link>
                        ) : (
                            "-"
                        )}
                      </TableData>
                      <TableData>
                        <span style={{ whiteSpace: 'nowrap' }}>
                          {request.lapsedAt ? formatDateTime(request.lapsedAt) : "-"}
                        </span>
                      </TableData>
                      <TableData>
                        <span style={{ whiteSpace: 'nowrap' }}>
                          {request.createdAt ? formatDateTimeWithSeconds(request.createdAt) : "-"}
                        </span>
                      </TableData>
                      <TableData>
                        <span style={{ whiteSpace: 'nowrap' }}>
                          {request.updatedAt ? formatDateTimeWithSeconds(request.updatedAt) : "-"}
                        </span>
                      </TableData>
                      <TableData align="right">
                        <Button
                          variant="contained"
                          size="small"
                          sx={{
                            width: 176,
                            height: 32,
                            whiteSpace: "nowrap",
                            textTransform: "none",
                            px: 1,
                          }}
                          onClick={()=>{
                            EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                            message: "Confirm credit coupon",
                            onClose: (confirmed: boolean) => {
                            oneMealService.creditLapsedVisit(Number(request?.id)).then((data)=>{
                                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                message: "Coupon credited successfully",
                                type: CustomSnackbarTypes.SUCCESS,
                                });
                                window.location.reload();
                            }).catch(error=>{
                                console.log(error);
                            })
                            },
                        });
                          }}
                        >
                            Credit Visit
                        </Button>
                      </TableData>
                    </CustomTableRowTR>
                  );
                })
              ) : !loading ? (
                <TableRow>
                  <TableCell colSpan={11} align="center" sx={{ py: 4 }}>
                    No lapsed visits found.
                  </TableCell>
                </TableRow>
              ) : null}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </TableWrapper>
    </>
  );
};

export default ComboLapsedVists;
